import React, { useEffect, useState } from 'react';

import { fetchPartnerDetailData } from '../../services/portfolioService';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import S from './Portfolio.module.css';

import { downIcon, buyIcon, notImg } from '../../assets/images/product/prodImages';

import { useParams } from 'react-router-dom';
import { SERVER_URL } from '../../config';
import BackListBtn from '../../components/Button/BackListBtn';
import InquiryBtn from '../../components/Button/InquiryBtn';

const PartnerDetailPage = () => {

  const { idx } = useParams();

  const [detailData, setDetailData] = useState();
  const [subImg, setSubImg] = useState([]);
  const [contentImg, setContentImg] = useState([]);
  const [file, setFile] = useState([]);
  const [mainImage, setMainImage] = useState(null);
  // const [filteredContentImg, setFilteredContentImg] = useState([]);


  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  
  useEffect(() => {
    const partnerDetailData = async () => {
      const ptData = await fetchPartnerDetailData(idx);
      const filteredContent = isMobile()
        ? ptData.C.filter(img => img.PF_CON_TYPE === 'M')
        : ptData.C.filter(img => img.PF_CON_TYPE === 'P');
  
      setDetailData(ptData.D);
      setSubImg(ptData.S);
      setContentImg(filteredContent);
      setFile(ptData.F);
      if(ptData.S.length > 0) {
        setMainImage(SERVER_URL + ptData.S[0].PF_PATH);
      }
    };

    partnerDetailData();
  }, []);

  const handleDownload = () => {
    if(file) {
      window.open(SERVER_URL + file[0].PF_PATH, '_blank');
    };
  };

  const handleMainImageClick = (imageUrl) => {
    setMainImage(imageUrl);
  };

  return (
    <div>
      <HeaderComponents pageKey="portfolio" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="portfolio" />
        </div>
        <div className='com-content-wrap mt-120'>
          <div style={{minHeight:'650px'}}>
            <div className='flex-row jt-con-between' id={S.ptTitleWrap}>
              <div className='flex-column jt-con-between'>
                <div id={S.ptDtTitle}>
                  {detailData && detailData[0].PT_SPEC ? detailData[0].PT_SPEC : ''} <br />
                  {detailData && detailData[0].PT_PRD_NAME ? detailData[0].PT_PRD_NAME : ''}
                </div>
                {isMobile() ? (
                <div className='w-70'>
                  <img src={mainImage} alt="Main Image" className={S.ptMainImg} />
                </div>
                ) : ''}
                {file && file.length > 0 && (
                  <div draggable className={S.downFileDiv} onClick={handleDownload}>
                    <a>카달로그</a>
                    <img src={downIcon} alt='icon'></img>
                  </div>
                )}
              </div>
              {!isMobile() ? (
                <div>
                  <img src={mainImage} alt="Main Image" className={S.ptMainImg} />
                </div>
              ) : ''}
            </div>
            <div id={S.lineDiv}></div>
            <div className='flex jt-con-between mt-50 mb-80' id={S.subImgWrapDiv}>
              {subImg && subImg.map((item, index) => (
                <img 
                  key={index}
                  src={SERVER_URL + subImg[index].PF_PATH} 
                  className={S.ptSubImg} 
                  onClick={() => handleMainImageClick(SERVER_URL + subImg[index].PF_PATH)}
                />
              ))}
              {subImg && subImg.length < 4 && (
                Array.from({ length: 4 - subImg.length }).map((_, index) => (
                  <img key={subImg.length + index} src={notImg} className={S.subImg}/>
                ))
              )}
            </div>
            <div className='mb-50'>
              {contentImg && contentImg.length > 0 && (
                <div>
                  <img src={SERVER_URL + contentImg[0].PF_PATH} className={S.contentImg}/>
                </div>
              )}
            </div>
            <div className='flex-row center mb-50' id={S.listBtn}>
              <BackListBtn text='목록으로' path='/portfolio/partner/1'/>&nbsp;&nbsp;&nbsp;&nbsp;
	      <InquiryBtn text='문의하기' path='/support/inquiry/1'/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerDetailPage;
